export default __webpack_public_path__ + "static/media/bni.2226e7f8.png";